import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { WebSocketContext } from '@/contexts/WebSocketContext';
import { CMDPsBetRecordSummaryQuery } from '@/models/cmd/live';
import { DateRangePicker } from '@/modules/report/components/DateRangePicker';
import { Box, Grid } from '@mui/material';
import { Moment } from 'moment';
import {
    Dispatch,
    SetStateAction,
    useContext,
    useEffect,
    useRef,
    useState,
} from 'react';
import { BetRecordSummary } from './betRecord/betRecordSummary';
import { GameTypeSelector } from './betRecord/betRecordSummary/components/GameTypeSelector';
// import { BetRecordTabPage } from './BetRecordTabs';
import { ScreenContext } from '@/contexts/ScreenContext';
import { useIsLobby } from '@/hooks/useIsLobby';
import { getBetSummaryReportState } from '@/modules/report/selector';
import { betSummarySliceActions } from '@/modules/report/slice/betSummary';
import { RwdTypography } from '@/modules/rwdGame/components/RwdTypography';
import { RootState } from '@/store/store';
import { t } from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import './index.scss';

type Props = {
    setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const QUERY_RECENT_ROUND = 10;

export const BetRecord = (props: Props) => {
    const isLobby = useIsLobby();
    const { setIsOpen } = props;

    const { playButtonAudio } = useContext(AudioPlayContext);
    const { sendCommand } = useContext(WebSocketContext);
    const { isLandscape } = useContext(ScreenContext);

    const [start, setStart] = useState<Moment>();
    const [end, setEnd] = useState<Moment>();
    const [expanded, setExpanded] = useState<boolean>(false);
    const [isRecent, setIsRecent] = useState<boolean>(true);
    const [isSummaryExpand, setIsSummaryExpand] = useState<boolean>(true);
    // const [page] = useState(BetRecordTabPage.SUCCESSFUL_BETS_PAGE);

    const [reportStartDate, setReportStartDate] = useState<string>('');
    const [reportEndDate, setReportEndDate] = useState<string>('');

    const timerRef = useRef<NodeJS.Timeout>();
    const [isRequest, setIsRequest] = useState<boolean>(false);

    const { summaries } = useSelector((state: RootState) =>
        getBetSummaryReportState(state)
    );

    const dispatch = useDispatch();
    const handleSubmit = async (
        _startDate: Moment,
        _endDate: Moment,
        isRecent: boolean,
        isSummaryExpand: boolean
    ) => {
        if (_startDate && _endDate) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            dispatch(betSummarySliceActions.reset()); // Reset bet summary
            setIsRequest(true);

            setReportStartDate(_startDate.locale('en').format('YYYY-MM-DD'));
            setReportEndDate(_endDate.locale('en').format('YYYY-MM-DD'));

            const request = new CMDPsBetRecordSummaryQuery();
            if (isRecent) {
                request.FromDate = '0';
                request.ToDate = '0';
            } else {
                request.FromDate = _startDate
                    .locale('en')
                    .format('YYYY-MM-DD 12:00:00');
                request.ToDate = _endDate
                    .locale('en')
                    .format('YYYY-MM-DD 11:59:59');
            }
            request.RecentRound = QUERY_RECENT_ROUND;
            await sendCommand(request);

            timerRef.current = setTimeout(() => {
                setIsRequest(false);
            }, 5000);

            setIsRecent(isRecent);
            setIsSummaryExpand(isSummaryExpand);
        } else {
            console.warn('app::report::betLog', 'please select date');
        }
    };

    const onClose = () => {
        playButtonAudio();
        setIsOpen(false);
    };

    // TODO- DELETE IT
    useEffect(() => {
        console.log(reportStartDate, reportEndDate);
    }, [onClose]);

    useEffect(() => {
        if (summaries != undefined) {
            setIsRequest(false);
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        }
    }, [summaries]);

    return (
        <>
            <div
                id="bet-summary-upper-section"
                style={{ position: 'relative' }}
            >
                {/* DateRangePicker */}
                <DateRangePicker
                    gaPrefix="btn_set-br"
                    start={start}
                    end={end}
                    expanded={expanded}
                    setStart={setStart}
                    setEnd={setEnd}
                    setExpanded={setExpanded}
                    showPreset={true}
                    showRecent={true}
                    handleSubmit={handleSubmit}
                    playButtonAudio={playButtonAudio}
                />
                {isLandscape && (
                    <Box className="bet-summary-game-type-selector-container">
                        <GameTypeSelector />
                    </Box>
                )}
            </div>
            {/* Bet Record Tabs */}
            {!isLandscape && (
                <Box className="bet-summary-game-type-selector-container">
                    <GameTypeSelector />
                </Box>
            )}
            {/* Up to latest 10 rounds */}
            {isRecent && (
                <Box className="bet-summary-recent-msg-container">
                    <Box className="bet-summary-recent-msg">
                        <RwdTypography
                            stepIndex={isLobby ? -1 : 0}
                            landscapeStepIndex={3}
                        >
                            {t(`betlog.latest_rounds`).replace(
                                '{{recent_rounds}}',
                                QUERY_RECENT_ROUND.toString()
                            )}
                        </RwdTypography>
                    </Box>
                </Box>
            )}
            {/* Records */}
            <Grid
                container
                direction="column"
                className="bet-summary-container"
            >
                <BetRecordSummary isSummaryExpand={isSummaryExpand} />
            </Grid>
            {/* workaround - fix footer padding */}
            <RwdTypography stepIndex={isLobby ? -1 : 0} landscapeStepIndex={3}>
                <span>&nbsp;</span>
            </RwdTypography>
            {/* Loading */}
            {isRequest && <div className="record-loading"></div>}
        </>
    );
};
